import { createTracker } from '@mathflat/data-tracking'

import {
  buildTeacherTrackerOptions,
  GLOBAL_PROPERTIES_VERSION,
  USER_PROPERTIES_VERSION,
} from './mixpanelConfig'
import type { ApiErrorEventName, ApiEventName } from './schema/apiEvent.schema'
import { eventCatalog } from './schema/event.schema'
import type { GlobalEventPropertiesSchema } from './schema/globalEventProperties.schema'
import type { UserPropertiesSchema } from './schema/userProperties.schema'

const tracker = createTracker(eventCatalog, buildTeacherTrackerOptions())

export const mixpanelClient = {
  track: tracker.track,
  identify: tracker.identify,
  setGlobalEventProperty: (props: Partial<GlobalEventPropertiesSchema>) =>
    tracker.setGlobalProps({ ...props, globalPropertiesVersion: GLOBAL_PROPERTIES_VERSION }),
  setUserProperty: (props: Partial<UserPropertiesSchema>) =>
    tracker.setUserProps({ ...props, userPropertiesVersion: USER_PROPERTIES_VERSION }),
}

type UncheckedRest =
  Parameters<typeof tracker.trackUnchecked> extends [string, ...infer R] ? R : never

// 이름이 실행 중에 정해지는 두 경로만 카탈로그 검사 없이 보낸다. 앱 나머지는 mixpanelClient.track 만 쓴다
export const sendApiEvent = (name: ApiEventName | ApiErrorEventName, ...rest: UncheckedRest) =>
  tracker.trackUnchecked(name, ...rest)

export const sendFramerEvent = (name: string, ...rest: UncheckedRest) =>
  tracker.trackUnchecked(name, ...rest)
